import React, { useState, useEffect, useReducer } from 'react';
import EirMobileCard from '../eir-mobile-card/EirMobileCard';
import Loading from '../shared/Loading';
import {
    Grid,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Button,
} from '@material-ui/core';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';
import EirMobileCardToggle from '../eir-mobile-card-toggle/EirMobileCardToggle';
import ResponsiveEirMobileCardContainer from '../eir-mobile-card-container/ResponsiveEirMobileCardContainer';
import EirSelectedPlanDetails from '../eir-selected-plan-details/EirSelectedPlanDetails';
import { PREPAY_REVIEW_URL } from '../eir-prepay-constants/ApplicationConstants';
import CloseIcon from '@material-ui/icons/Close';

export const BtnContext = React.createContext();

function EirMobileCardContainer(props) {
    const [btnState, setBtnState] = useState(null);
    const initialState = 0;
    const reducer = (state, action) => {
        switch (action) {
            case 'true':
                setBtnState(1);
                return (state = 1);
            case 'false':
                setBtnState(0);
                return (state = 0);
            default:
                setBtnState(0);
                return (state = 0);
        }
    };
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [submitPlanUrl, setSubmitPlanUrl] = useState(PREPAY_REVIEW_URL);
    const [custOffers, setCustOffers] = useState(null);
    const [selectedText, setSelectedText] = useState(null);
    const [handsetName, setHandsetName] = useState(null);
    const [changeLink, setChangeLink] = useState(null);
    const graphql = useApolloClient();
    const [btn, dispatch] = useReducer(reducer, initialState);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [APIStatus, setAPIStatus] = useState('');
    const handleClose = () => {
        setDialogOpen(false);
    };
    const setDialogOpenResponse = response => {
        setDialogOpen(response);
    };
    const setAPIErrorResponse = response => {
        setAPIStatus(response);
    };

    var planList = [];
    useEffect(() => {
        props.bundleOfferLists[0].bundleOffers.map(plan => planList.push(plan.id));
        setIsLoading(true); //setting the loading as true as data still not fetched
        requestAPI();
        setIsLoading(false);
        setSelectedPhoneDetails();
        localStorage.removeItem('ulHeightTemp');
    }, []);

    const requestAPI = async () => {
        try {
            const res = await graphql.query({
                query: ENDPOINT.GET_PLANS,
                variables: { planIds: planList },
            });
            if (res.data.plans) {
                setCustOffers(res.data.plans);
            }
        } catch (err) {
            console.log(err.message);
        }
    };
    const setSelectedPhoneDetails = () => {
        setSelectedText('Selected phone:');
        setHandsetName(localStorage.getItem('handset-name'));
        setChangeLink('/mobile/phones/prepay/');
    };
    if (error) {
        return <h2 className='text-center'>Error</h2>;
    } else if (isLoading) {
        return <Loading className='m-5' />;
    } else {
        return (
            <React.Fragment className='responsive-container'>
                {APIStatus && (
                    <Dialog
                        PaperProps={{ className: 'prepaydialogPaper' }}
                        open={dialogOpen}
                        onClose={handleClose}
                        aria-labelledby='alert-dialog-title'
                        aria-describedby='alert-dialog-description'
                        className='prepayeirDialogContainer'>
                        <DialogTitle id='alert-dialog-title' className='dialogTitle'></DialogTitle>
                        <IconButton
                            aria-label='close'
                            className='prepaycloseButton'
                            onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                        <DialogContent className='prepayeirDialogContent'>
                            <DialogContentText
                                id='alert-dialog-description'
                                className='prepaynotification'>
                                {APIStatus}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                align='center'
                                className='prepayeirDialog'>
                                <Button className='prepaycancelBtn' onClick={handleClose}>
                                    Close
                                </Button>
                            </Grid>
                        </DialogActions>
                    </Dialog>
                )}
                {!custOffers ? (
                    <Loading className='m-5' />
                ) : (
                    <form action={submitPlanUrl} method='post'>
                        <Grid container justify='center' className='prepay'>
                            {handsetName ? (
                                <EirSelectedPlanDetails
                                    selectedText={selectedText}
                                    detailsText={handsetName}
                                    changeLink={changeLink}
                                />
                            ) : (
                                <EirMobileCardToggle onChange={handleChange}></EirMobileCardToggle>
                            )}
                        </Grid>
                        <BtnContext.Provider value={{ countState: btn, countDispatch: dispatch }}>
                            <ResponsiveEirMobileCardContainer count={custOffers.length}>
                                {custOffers != undefined &&
                                    Object.keys(custOffers).map(custOffer => {
                                        let offer = custOffers[custOffer];
                                        let bundleOffer = props.bundleOfferLists[0].bundleOffers.find(bundleOffer => bundleOffer.id === offer.planId);
                                        return (
                                            <React.Fragment key={offer.planId}>
                                                <EirMobileCard
                                                    subtitles={offer.attributes
                                                        .filter(
                                                            attribute =>
                                                                attribute.name === 'strapline'
                                                        )
                                                        .map(attribute => attribute.value)}
                                                    mainFeatures={offer.attributes
                                                        .filter(
                                                            attribute =>
                                                                attribute.name === 'mainfeature'
                                                        )
                                                        .map(attribute => attribute.value)}
                                                    price={offer.price}
                                                    features={offer.attributes
                                                        .filter(
                                                            attribute =>
                                                                attribute.name === 'feature'
                                                        )
                                                        .map(attribute => attribute.value)}
                                                    ctaName={offer.planId}
                                                    ctaValue={offer.planId}
                                                    submitPlanUrl={submitPlanUrl}
                                                    name={offer.name}
                                                    openCMSProps={props}
                                                    btn={btnState == 1 ? true : false}
                                                    getAPIError={setAPIErrorResponse}
                                                    getsetDialogOpenResponse={setDialogOpenResponse}
                                                    promoString={bundleOffer.promoString}
                                                />
                                            </React.Fragment>
                                        );
                                    })}
                            </ResponsiveEirMobileCardContainer>
                        </BtnContext.Provider>
                    </form>
                )}
            </React.Fragment>
        );
    }

    function handleChange(newUrl) {
        setSubmitPlanUrl(newUrl);
    }
}
export default EirMobileCardContainer;
